import React from "react";
import PropTypes from "prop-types";
import { useFormContext, useController } from "react-hook-form";

import VStack from "shared/components/layout/stack/VStack";
import FormInputWrapper from "shared/components/inputs/form/FormInputWrapper";
import { getFeedbackProps } from "shared/components/inputs/form-fields/utils";
import ToggleButton, {
    StyledLabel,
    WrapperToggleButton,
} from "shared/components/inputs/toggle-button/ToggleButton";
import Text from "shared/components/data-display/text/Text";
import { Wrapper } from "./ToggleInputForm.styles";

const ToggleInputForm = ({
    name,
    label,
    defaultSelection,
    validations = {},
    disabled,
}) => {
    const {
        formState: { errors },
    } = useFormContext();
    const { field } = useController({
        name,
        rules: validations,
        defaultValue: defaultSelection ?? false,
    });

    const { value, onChange } = field;

    const fieldErrors = errors[name];
    const feedbackProps = getFeedbackProps(fieldErrors);

    return (
        <Wrapper>
            <VStack>
                <WrapperToggleButton $disabled={disabled}>
                    {label && (
                        <StyledLabel
                            spacing="Zero_5"
                            align="center"
                            $disabled={disabled}
                            $checked={value}
                        >
                            <ToggleButton
                                disabled={disabled}
                                checked={value}
                                onChange={(e) => {
                                    onChange(e.target.checked);
                                }}
                            />
                            <Text variant={value ? "Body_2_2" : "Body_2_1"}>
                                {value ? label[1] : label[0]}
                            </Text>
                        </StyledLabel>
                    )}
                </WrapperToggleButton>
                {feedbackProps.feedbackMessage && (
                    <FormInputWrapper {...feedbackProps} />
                )}
            </VStack>
        </Wrapper>
    );
};

ToggleInputForm.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.array,
    defaultSelection: PropTypes.bool,
    validations: PropTypes.object,
    disabled: PropTypes.bool,
};

export default ToggleInputForm;
